<template>
	<div>
		
		<EbModal v-if="isDeleteModal" type="destructive" title="Supprimer une disponibilité future ?" text="Vous êtes sur le point de supprimer définitivement une disponibilité future." @close="isDeleteModal=false" @validate="deleteDisponibilite"></EbModal>
		
		<EbHeading level="h1" v-if="!dispoId && !isMobile" class="eb-page-heading">Ajouter une disponibilité future</EbHeading>
		<EbHeading level="h1" v-if="dispoId && !isMobile" class="eb-page-heading">Modifier la disponibilité future</EbHeading>
		<div class="eb-content-default">
			<EbHeading level="h2" v-if="!dispoId" class="eb-box-heading">J'ai une place disponible</EbHeading>
			
			<form action="#" @submit.prevent="sendDisponibilite()">
				<EbInput label="À partir du (jj/mm/aaaa)" type="date" inline required v-model="dispoFuture.dateDebut" :min="minDate"></EbInput>
				
				<fieldset v-if="agrement">
					
					<legend class="eb-legend-label"><span class="eb-legend-label-mandatory-icon"><i class="fa fa-solid fa-asterisk fa-w-16"></i></span> Tranches d’âge (obligatoire)</legend>
					
					<EbRadio v-for="(a, index) in agrement.types" :label="a.trancheAge" v-model.number="a.idTrancheAge" :key="index" name="trancheage" @input="changeTrancheAge" :checked="dispoFuture.idTrancheAgeSolis == a.idTrancheAge ? true:false"></EbRadio>
					
				</fieldset>
				
				<div class="eb-button-group">
					<EbButton v-if="!dispoId" type="submit">Ajouter la disponibilité</EbButton>
					<EbButton v-else type="submit">Modifier la disponibilité</EbButton>
					
					<EbButton v-if="dispoId" @click.prevent="isDeleteModal=true" hierarchy="secondary" type="submit">Supprimer la disponibilité</EbButton>
					
					<EbLinkButton :to="{name: 'dispos'}" class="text">Annuler la saisie</EbLinkButton>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	name: "dispoFuture",
	props: {
		dispoId: {
			type: [Number, String],
			default: null,
		},
	},
	data() {
		return {
			dispoFuture: {
				dateDebut: null,
				idTrancheAgeSolis: null,
				nombrePlaces: 1
			},
			agrement: null,
			isDeleteModal: false,
			isBannerActive: false,
			bannerTimestamp: '',
			bannerType: null,
			bannerTitle: '',
			bannerContent: ''
			
		}
	},
	computed: {
		minDate: function() {
			const tomorrow = new Date()
			tomorrow.setDate(tomorrow.getDate() + 1)
			return tomorrow.toISOString().slice(0, 10)
		},
	},
	mounted() {
		this.getAgrement()
		if (this.dispoId) this.getDisponibilites()
	},
	methods: {
		getDisponibilites: async function() {
			await this.$http.get(`assmat/disponibilitesFutures/${this.dispoId}`).then(resp => {
				this.dispoFuture = resp.data
			})
		},
		setDisponibilite: async function() {
			await this.$http
			.post("assmat/disponibilitesFutures", this.dispoFuture)
			.then(resp => {
				this.$router.push({name: "dispos", params: {status: 'create'}})
			})
			.catch(error => {
				this.isBannerActive = true
				this.bannerType = 'error'
				this.bannerContent = 'Une erreur est survenue, veuillez vérifier votre saisie.'
			})
		},
		updateDisponibilite: async function() {
			await this.$http
			.put("assmat/disponibilitesFutures", this.dispoFuture)
			.then(resp => {
				this.$router.push({name: "dispos", params: {status: 'update'}})
			})
			.catch(error => {
				this.isBannerActive = true
				this.bannerType = 'error'
				this.bannerContent = 'Une erreur est survenue, veuillez vérifier votre saisie.'
			})
		},
		deleteDisponibilite: async function() {
			await this.$http
			.delete(`assmat/disponibilitesFutures/${this.dispoId}`)
			.then(resp => {
				this.$router.push({name: "dispos", params: {status: 'delete'}})
			})
			.catch(error => {
				this.isBannerActive = true
				this.bannerType = 'error'
				this.bannerContent = 'Une erreur est survenue, veuillez vérifier votre saisie.'
			})
		},
		sendDisponibilite: function() {
			this.isSave = false
			if(this.dispoId) this.updateDisponibilite()
			else this.setDisponibilite()
		},
		getAgrement: async function() {
			await this.$http.get('assmat/agrement')
			.then(resp => {
				this.agrement = resp.data
				
				if(!this.dispoId) this.dispoFuture.idTrancheAgeSolis = this.agrement.types[0].idTrancheAge
			})
		},
		changeTrancheAge: function(value) {
			this.dispoFuture.idTrancheAgeSolis = Number(value)
		}
	},
}
</script>

<style lang="scss" scoped>
.eb-legend-label {
	cursor: pointer;
	@include stack-space($eb-space-default);
	
	&-mandatory {
		&-icon {
			color: $eb-color-error;
			margin-right: $eb-space-xs;
			font-size: 50%;
			top: -$eb-space-s;
			position: relative;
		}
	}
}
</style>